import { render, staticRenderFns } from "./SbgCabangReport.vue?vue&type=template&id=7d96cdfb&scoped=true&"
import script from "./SbgCabangReport.vue?vue&type=script&lang=js&"
export * from "./SbgCabangReport.vue?vue&type=script&lang=js&"
import style0 from "./SbgCabangReport.vue?vue&type=style&index=0&id=7d96cdfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d96cdfb",
  null
  
)

export default component.exports